import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import SummaryList from '../shared/SummaryList';
import Title from '../shared/Title';
import { createOverflow } from '../../lib/format';

const LineupSummaryList = ({ team, summary, pathTo, season }) => {
  const overflow = createOverflow(team, season);

  return (
    <div className="s-lineups">
      <Title
        team={team}
        linkTo={pathTo('team')}
        subtitle="Lineup Summary"
        overflow={overflow}
      />

      <div className="action-bar action-bar--align-end">
        <Link to={pathTo('lineup-explorer')} className="btn-info">
          Lineup Explorer
        </Link>
      </div>

      <div className="summary-box__list">
        {summary.map(group => (
          <SummaryGroup key={group.title} group={group} pathTo={pathTo} />
        ))}
      </div>
    </div>
  );
};

LineupSummaryList.propTypes = {
  team: PropTypes.object,
  lineups: PropTypes.object,
  pathTo: PropTypes.func.isRequired,
};

export default LineupSummaryList;

const SummaryGroup = ({ group, pathTo }) => {
  return (
    <div>
      <h2>{group.title}</h2>
      {group.items.map(summary => (
        <SummaryList
          key={summary.id}
          title={summary.name}
          items={summary.items}
          pathTo={pathTo}
        />
      ))}
    </div>
  );
};
